export default "__VITE_ASSET__TLita7G3__"